﻿KendoTweaks = (function () {
  var setGridVisibility = function (datasource, noDataMessage, gridContainer) {
    var count = datasource.total();
    $(count === 0 ? gridContainer : noDataMessage).hide();
    $(count === 0 ? noDataMessage : gridContainer).show();
  };

  return {
    setGridVisibility: setGridVisibility,
  };
})();

$(function () {
  $(document).on('change', '.k-input', function () {
    if ($(this).hasClass('input-validation-error')) {
      $(this).parent().addClass('input-validation-error');
    } else {
      $(this).parent().removeClass('input-validation-error');
    }
  });

  // needed to set a timeout, otherwise it is executed to early
  setTimeout(function () {
    $('.k-input.input-validation-error').each(function () {
      if (!$(this).parent().hasClass('input-validation-error')) {
        $(this).parent().addClass('input-validation-error');
      }
    });
  }, 0);
});
